"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _dispositionl = require("@/api/dispositionl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SubcommissionAllocation',
  data: function data() {
    return {
      ruleForm: {
        rate: null,
        // 分佣比例
        status: false
      },
      dialogVisible: false
    };
  },
  mounted: function mounted() {
    this.getRegionApi();
  },
  methods: {
    handleInput: function handleInput(value) {
      // 使用正则表达式来判断输入是否合法
      if (value > 100) {
        this.ruleForm.rate = 100;
      } else if (value < 0) {
        this.ruleForm.rate = 0;
      }
    },
    // 编辑
    onEditor: function onEditor() {
      this.dialogVisible = true;
    },
    // 关闭弹窗
    onclose: function onclose() {
      this.dialogVisible = false;
    },
    // 列表
    getRegionApi: function () {
      var _getRegionApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {};
              _context.n = 1;
              return (0, _dispositionl.getRegionApi)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.ruleForm.rate = res.data.rate;
                this.ruleForm.status = !!res.data.status;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getRegionApi() {
        return _getRegionApi2.apply(this, arguments);
      }
      return getRegionApi;
    }(),
    // 确认
    onEditorVerify: function onEditorVerify() {
      this.updateRegionApi();
    },
    // 开关
    onSwitchChange: function onSwitchChange() {
      this.updateRegionApi();
    },
    // 编辑
    updateRegionApi: function () {
      var _updateRegionApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {
                rate: Number(this.ruleForm.rate)
              };
              if (this.ruleForm.status) {
                params.status = 1;
              } else {
                params.status = 0;
              }
              _context2.n = 1;
              return (0, _dispositionl.updateRegionApi)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '编辑成功'
                });
                this.onclose();
                this.getRegionApi();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function updateRegionApi() {
        return _updateRegionApi2.apply(this, arguments);
      }
      return updateRegionApi;
    }()
  }
};